import * as R from 'ramda';
// helpers/constants
import * as G from '../../helpers';
///////////////////////////////////////////////////////////////

const groupByItemId = (prop, value, allIntObj) => {
  const isSelected = (item) => R.equals(R.path([prop], item), value);
  const selectedList = R.map(
    (item) => item,
    R.filter(isSelected, allIntObj),
  );
  return R.assoc(value, selectedList, {});
};

export const makeSettingInfo = (intObj) => R.reduce((prev, locale) => (
    R.concat(prev, R.values(locale).map(({ itemId }) => itemId))
  ), [], intObj);

export const makeCurrentIntObj = (data) => {
  const itemIdArray = R.uniq(makeSettingInfo(data));
  const allIntObj = R.flatten(data);
  const newObj = R.mergeAll(itemIdArray.map((itemId) => groupByItemId('itemId', itemId, allIntObj)));
  const indexedObj = R.mapObjIndexed((item) => R.indexBy(R.prop('language'), item), newObj);
  return indexedObj;
};

export const convertToOptions = (list) => {
  if (G.isNilOrEmpty(list)) return [];
  return R.map((item) => ({
    label: R.path(['name'], item),
    value: R.path(['guid'], item),
  }), list);
};

export const changeStyleOnHover = (
  pattern,
  activeTab,
  hoverStyle,
  currentStyle,
) => (
  G.ifElse(
    R.equals(pattern, activeTab),
    hoverStyle,
    currentStyle,
  )
);
